import React from "react";
import Routing from "./Routing/Routing";

const App = () => {
  return <Routing />;
};

export default App;
